import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Profile2 from "../../assets/Feedback_imgs/Mask group.png";
import Profile3 from "../../assets/Profile_img/Mask group-1.png";
import profile4 from '../../assets/Profile_img/Mask group-2.png'
import profile5 from '../../assets/Profile_img/Mask group-3.png'
import profile6 from '../../assets/Profile_img/Mask group.png'

export default function Testimonial() {
  const settings = {
    dots: false,
    arrow: true,
    infinite: true,
    speed: 900,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: false,
    margin: 30,
  };

  const TestimonilContent = [
    {
      desc: `We cherish the solid bond we have established with Raiden. Their team's commitment and understanding of our requirements have made them a reliable collaborator.`,
      reviewerImg: Profile3,
      reviewerName: "Valerie Reid",
      designation: "Client",
    },
    {
      desc: `Raiden's cost-effectiveness, combined with the results we have achieved, makes them an excellent choice.`,
      reviewerImg: Profile2,
      reviewerName: "Julian Alric",
      designation: "Client",
    },
    {
      desc: `Simple to adopt, highly cost-effective, and the results were transformative. Raiden is the smart choice.`,
      reviewerImg: profile6,
      reviewerName: "Ananya Mehta",
      designation: "Client",
    },
    {
      desc: `We got maximum impact and value from Raiden's innovative approach on a real-world budget.`,
      reviewerImg: profile5,
      reviewerName: "Victor H",
      designation: "Client",
    },
    {
      desc: `We needed future-proof results, and Raiden provided just that. The level of innovation they brought to the table is unmatched.`,
      reviewerImg: Profile2,
      reviewerName: "Hayes Soto",
      designation: "Client",
    },
  ];

  return (
    <Slider {...settings}>
      {TestimonilContent.map((val, i) => (
        <div
          className="item"
          key={i}
          data-aos="fade-up"
          data-aos-duration="1200"
        >
          <p className="font-gordita">{val.desc}</p>
          <div className="d-lg-flex align-items-center">
            <img
              src={val.reviewerImg}
              alt=""
              className="c_img m-0"
            />
            <div className="info">
              <strong>{val.reviewerName}</strong>
            </div>
          </div>
        </div>
      ))}
    </Slider>
  );
}
